export const REMOVE_ALL_DATA_BTN_TEXT = 'Remove All My Data';
